// src/components/Welcome/XpheriumLogo.jsx
//
// Mirror of landing/src/components/ui/XpheriumLogo.tsx so the React SPA
// can render the same brand mark as the marketing site. Kept here (rather
// than in a shared package) because the two codebases are independently
// deployed.

import React from 'react';

const SIZE_HEIGHTS = { sm: 36, md: 44, lg: 52 };

export default function XpheriumLogo({ className = '', size = 'md', variant = 'light' }) {
  const h = SIZE_HEIGHTS[size] || SIZE_HEIGHTS.md;
  const w = Math.round(h * 2.56);
  const fill = variant === 'light' ? '#ffffff' : '#0f172a';

  return (
    <svg
      width={w}
      height={h}
      viewBox="60 178 395 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Xpherium"
    >
      {/* Xm symbol */}
      <path
        fill={fill}
        fillRule="evenodd"
        d="M 64 182 L 93 225 L 103 238 L 103 241 L 65 295 L 92 295 L 117 260 L 120 261 L 131 278 L 173 278 L 173 240 L 175 234 L 181 230 L 185 230 L 189 232 L 193 237 L 193 278 L 210 278 L 210 237 L 217 230 L 223 230 L 227 232 L 230 237 L 230 278 L 248 278 L 248 231 L 242 220 L 231 214 L 215 214 L 209 217 L 203 223 L 196 217 L 190 214 L 173 214 L 167 217 L 159 224 L 156 231 L 156 266 L 154 267 L 152 265 L 151 262 L 135 240 L 135 237 L 174 182 L 147 182 L 121 218 L 118 216 L 110 203 L 95 183 L 93 182 Z"
      />
      {/* XPHERIUM wordmark */}
      <path
        fill={fill}
        fillRule="evenodd"
        d="M 135 294 L 146 309 L 147 313 L 134 332 L 143 332 L 151 320 L 153 320 L 155 322 L 161 332 L 171 332 L 157 314 L 157 312 L 170 294 L 161 294 L 153 306 L 151 305 L 144 294 Z  M 203 295 L 199 294 L 180 294 L 180 332 L 187 332 L 187 320 L 188 319 L 190 320 L 192 319 L 200 319 L 207 315 L 209 311 L 209 303 L 207 299 Z  M 187 301 L 188 300 L 197 300 L 202 306 L 201 310 L 198 313 L 194 313 L 193 314 L 188 313 L 187 312 Z  M 219 294 L 219 332 L 226 332 L 226 317 L 227 316 L 244 316 L 245 317 L 245 332 L 252 332 L 252 294 L 245 294 L 245 308 L 244 309 L 227 309 L 226 308 L 226 294 Z  M 264 294 L 264 332 L 290 332 L 290 325 L 273 325 L 272 324 L 272 317 L 273 316 L 288 316 L 288 309 L 273 309 L 272 308 L 272 301 L 273 300 L 290 300 L 290 294 Z  M 301 294 L 301 332 L 309 332 L 309 319 L 310 318 L 316 318 L 324 332 L 333 332 L 325 320 L 325 318 L 331 312 L 332 304 L 330 299 L 327 296 L 322 294 Z  M 309 301 L 310 300 L 319 300 L 321 301 L 324 305 L 323 310 L 319 313 L 310 313 L 309 312 Z  M 343 294 L 343 332 L 350 332 L 350 294 Z  M 363 294 L 363 323 L 366 328 L 370 331 L 376 333 L 381 333 L 389 330 L 393 326 L 395 321 L 395 294 L 388 294 L 388 317 L 386 323 L 381 326 L 377 326 L 371 322 L 370 320 L 370 294 Z  M 408 294 L 408 332 L 415 332 L 415 310 L 416 309 L 418 310 L 426 326 L 432 326 L 432 324 L 438 315 L 438 313 L 442 309 L 443 310 L 443 332 L 450 332 L 450 297 L 451 296 L 450 294 L 441 294 L 430 315 L 427 313 L 418 294 Z"
      />
    </svg>
  );
}
